module.exports = __webpack_public_path__ + "static/media/ShippersExpress.8e2e759c.png";